export enum EnumDispatchType {
  Nominacion = 1,
  Reparto02G = 2,
  Reparto03G = 3,
  NominacionConRepartos = 4
}
